import React from "react";
import { Link } from "react-router-dom";
import { useAutoDismissMessage } from "../../../shared/hooks/useAutoDismissMessage";

const API_URL = process.env.REACT_APP_API_URL;
const REQUEST_RESET_ENDPOINT = "/password-reset.php?action=request";

export default function OlvidePassword() {
  const [identificador, setIdentificador] = React.useState("");
  const [mensaje, setMensaje] = React.useState("");
  const [error, setError] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  useAutoDismissMessage(mensaje, () => setMensaje(""));
  useAutoDismissMessage(error, () => setError(""));

  const solicitarRecuperacion = async (e) => {
    e.preventDefault();
    setMensaje("");
    setError("");
    setIsLoading(true);

    try {
      const res = await fetch(`${API_URL}${REQUEST_RESET_ENDPOINT}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ identificador })
      });

      const data = await res.json();

      if (res.ok && data?.ok !== false) {
        setMensaje(data?.mensaje || "Si el usuario existe, enviaremos instrucciones de recuperacion.");
        setIdentificador("");
      } else {
        setError(data?.mensaje || data?.error || "No fue posible solicitar la recuperacion.");
      }
    } catch (err) {
      setError("No hay conexion con el servidor. Intenta nuevamente en unos minutos.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <main className="login-page">
      <section className="login-shell" aria-label="Recuperacion de contrasena">
        <div className="login-hero">
          <div className="login-brand">
            <span className="login-brand-mark">A</span>
            <div>
              <p>Agenda Terapeutica</p>
              <span>Recuperacion de acceso</span>
            </div>
          </div>

          <div className="login-copy">
            <h1>Recupera el acceso a tu agenda.</h1>
            <p>
              Ingresa tu usuario o correo para recibir un enlace temporal y crear una nueva contrasena.
            </p>
          </div>
        </div>

        <div className="login-panel">
          <div className="login-panel-header">
            <p>Acceso</p>
            <h2>Olvide mi contrasena</h2>
            <span>Te enviaremos instrucciones si encontramos una cuenta asociada.</span>
          </div>

          {mensaje && <div className="login-alert login-alert-success">{mensaje}</div>}
          {error && <div className="login-alert">{error}</div>}

          <form onSubmit={solicitarRecuperacion} className="login-form">
            <div className="login-field">
              <label htmlFor="identificador">Usuario o correo</label>
              <input
                id="identificador"
                type="text"
                value={identificador}
                onChange={(e) => setIdentificador(e.target.value)}
                placeholder="Usuario o correo registrado"
                autoComplete="username"
                required
              />
            </div>

            <button type="submit" className="login-submit" disabled={isLoading}>
              {isLoading ? "Enviando..." : "Enviar instrucciones"}
            </button>
          </form>

          <p className="login-note">
            <Link className="login-link" to="/login">Volver al inicio de sesion</Link>
          </p>
        </div>
      </section>
    </main>
  );
}
